import React, { Component } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import $ from 'jquery';

export default class ViewCreditUsage extends Component {
    constructor() {
        super();
        this.state = {
            dateRangeVal: [new Date().toDateString(), new Date().toDateString()],
            usageData: [],
            viewCreditUsage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            },
        }
    }
    onChangeDatePicker = (e) => {
        this.state.dateRangeVal = [e[0].toDateString(), e[1].toDateString()];
        this.setState(this.state);
        this.getDailyCreditsUsage();
    }

    getDailyCreditsUsage = () => {
        var viewCreditUsageComponent = this;
        viewCreditUsageComponent.state.viewCreditUsage.datasets[0].data = [];
        viewCreditUsageComponent.state.viewCreditUsage.labels = [];
        var startDate = viewCreditUsageComponent.state.dateRangeVal[0];
        var endDate = viewCreditUsageComponent.state.dateRangeVal[1];
        $.ajax({
            url: "/api/get-daily-creadits-usage",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId"),
                "startDate": startDate,
                "endDate": endDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        viewCreditUsageComponent.state.usageData = res.result;
                        viewCreditUsageComponent.setState(viewCreditUsageComponent.state);

                        viewCreditUsageComponent.setState(viewCreditUsageComponent.state);
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    render() {
        return (
            <div>
                <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                <div className="row" style={{ marginTop: '40px' }}>
                    <div className="col-sm-6" style={{ paddingLeft: '60px', paddingTop: '25px' }}>
                        <label style={{ fontSize: '16px', color: '#282a65' }}><b>Credit Usage Summary</b></label>
                    </div>
                    <div className="col-sm-6" align="right" style={{ paddingRight: '60px' }}>
                        <DateRangePicker
                            clearIcon={null}
                            format="dd/MM/yyyy"
                            maxDate={new Date()}
                            rangeDivider=" -"
                            autoFocus={true}
                            onChange={this.onChangeDatePicker}
                            value={this.state.dateRangeVal}
                        />
                    </div>

                </div>
                <div style={{ border: '1px solid #282a65', margin: '50px', marginTop: '30px', borderRadius: '8px' }}>
                    <div style={{ margin: '30px' }}>
                        <div style={{ display: 'flex' }}>
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                fontSize: '1.2rem'
                            }}>Usage from {this.state.dateRangeVal[0]} to {this.state.dateRangeVal[1]}</h6>
                        </div>
                        {this.state.usageData.map(item => (
                            <div className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '30px',
                                fontSize: '1.1rem'
                            }}>{item.name} : {item.value}</div>
                        ))}
                    </div>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/header/ViewCreditUsage.js